import { useMutation } from '@apollo/client';

import { AddBedroomToPlaceInput } from '../../apollo/__generated__/graphql';
import { ADD_BEDROOM_TO_PLACE } from '../graphql/mutation/addBedroomToPlaceMutation.graphql';
import { BEDROOMS } from '../graphql/query/bedroomsQuery.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';
import { PLACES } from '../graphql/query/placesQuery.graphql';

export const useAddBedroomToPlaceMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(ADD_BEDROOM_TO_PLACE, { onCompleted });

  const addBedroomToPlace = (
    addBedroomToPlaceInput: AddBedroomToPlaceInput,
  ) => {
    mutate({
      variables: {
        addBedroomToPlaceInput,
      },
      refetchQueries: [
        {
          query: BEDROOMS,
          variables: { placeId: addBedroomToPlaceInput.placeId },
        },
        PLACES,
        EVENT_BEDROOMS,
      ],
    });
  };

  return { addBedroomToPlace };
};
